import accountInfoImport from './accountInfo'

export const accountInfo = accountInfoImport
